module.exports = __webpack_public_path__ + "static/media/Koryu No Mimi - Box Cover.90de20ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/box/Koryu No Mimi - Box Cover.jpg
// module id = 89
// module chunks = 0